import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { COMPANY_ADDRESS, COMPANY_EMAIL } from '../config';
import '../css/PrivacyPage.css';

const OWNER = 'ФОП Фігура Тетяна Богданівна';
const EDRPOU = '2586412525';
const SITE = 'union-auto.com.ua';
const EFFECTIVE_DATE = '01.01.2025';

const PrivacyPage = () => {
    return (
        <Layout>
            <SEO
                title="Політика конфіденційності"
                description={`Політика конфіденційності інтернет-магазину UnionAuto (${SITE}). Порядок збору, обробки та захисту персональних даних користувачів.`}
                canonical="/privacy-policy"
                noindex
            />
            <div className="privacy-page">
                <header className="privacy-header">
                    <h1 className="privacy-title">Політика конфіденційності</h1>
                    <p className="privacy-date">Набирає чинності: {EFFECTIVE_DATE}</p>
                </header>

                <section className="privacy-section">
                    <h2>1. Загальні положення</h2>
                    <p>
                        Ця Політика конфіденційності (далі — «Політика») розроблена {OWNER} (код ЄДРПОУ: {EDRPOU},
                        далі — «Продавець») відповідно до Закону України «Про захист персональних даних»
                        від 01.06.2010 № 2297-VI та з урахуванням принципів Регламенту GDPR ЄС.
                    </p>
                    <p>
                        Політика визначає порядок збору, обробки, зберігання та захисту персональних даних
                        користувачів сайту <strong>{SITE}</strong> (далі — «Сайт»).
                    </p>
                    <p>
                        Користуючись Сайтом або оформлюючи замовлення, ви підтверджуєте свою згоду з умовами
                        цієї Політики.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>2. Які дані ми збираємо</h2>
                    <p>Продавець може збирати такі персональні дані:</p>
                    <ul>
                        <li>ім'я та прізвище;</li>
                        <li>номер телефону;</li>
                        <li>адреса електронної пошти;</li>
                        <li>адреса доставки (місто, відділення або адреса);</li>
                        <li>технічні дані: IP-адреса, тип браузера, операційна система, сторінки що переглядалися
                            (автоматично, через Google Analytics).</li>
                    </ul>
                    <p>
                        Ми не збираємо та не обробляємо чутливі персональні дані (расове або етнічне
                        походження, політичні погляди, релігійні переконання, стан здоров'я тощо).
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>3. Мета обробки даних</h2>
                    <p>Ваші дані використовуються виключно для:</p>
                    <ul>
                        <li>оформлення та виконання замовлень (зв'язок, уточнення деталей, доставка);</li>
                        <li>інформування про статус замовлення;</li>
                        <li>відповіді на запити, скарги та звернення;</li>
                        <li>аналізу відвідуваності та покращення роботи Сайту (Google Analytics).</li>
                    </ul>
                    <p>
                        Ми не використовуємо ваші дані для маркетингових розсилок без вашої явної згоди.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>4. Передача даних третім особам</h2>
                    <p>
                        Ваші персональні дані можуть передаватися третім особам лише у таких випадках:
                    </p>
                    <ul>
                        <li>
                            <strong>Служба доставки «Нова Пошта»</strong> — для оформлення та відправлення
                            замовлення через відділення, поштомат або кур'єрську доставку. Передаються лише ім'я
                            та контактні дані, необхідні для доставки.
                        </li>
                        <li>
                            <strong>Google LLC</strong> — через сервіс Google Analytics (аналітика
                            відвідуваності). Дані обробляються анонімно, відповідно до{' '}
                            <a
                                href="https://policies.google.com/privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="privacy-link"
                            >
                                Політики конфіденційності Google
                            </a>.
                        </li>
                        <li>
                            <strong>Органи державної влади</strong> — за обґрунтованими запитами відповідно
                            до чинного законодавства України.
                        </li>
                    </ul>
                    <p>
                        В усіх інших випадках дані не розкриваються і не передаються без вашої згоди.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>5. Файли Cookie</h2>
                    <p>
                        Сайт використовує файли cookie для коректної роботи та збору аналітики через
                        Google Analytics. Cookies — це невеликі текстові файли, що зберігаються у вашому
                        браузері.
                    </p>
                    <p>
                        Ви можете відключити cookies у налаштуваннях браузера. Зверніть увагу: деякі
                        функції Сайту можуть працювати некоректно після цього.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>6. Зберігання даних</h2>
                    <p>
                        Персональні дані зберігаються протягом строку, необхідного для виконання мети їх
                        збору, але не більше <strong>3 (трьох) років</strong> з дати останньої взаємодії
                        з Продавцем, якщо інше не передбачено чинним законодавством України.
                    </p>
                    <p>
                        Після закінчення строку зберігання дані видаляються або знеособлюються.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>7. Ваші права</h2>
                    <p>
                        Відповідно до статті 8 Закону України «Про захист персональних даних», ви маєте
                        право:
                    </p>
                    <ul>
                        <li>знати, які ваші дані обробляються та з якою метою;</li>
                        <li>отримати доступ до своїх персональних даних;</li>
                        <li>вимагати виправлення неточних або застарілих даних;</li>
                        <li>вимагати видалення своїх даних («право на забуття»);</li>
                        <li>відкликати згоду на обробку даних у будь-який момент;</li>
                        <li>подати скаргу до Уповноваженого Верховної Ради України з прав людини.</li>
                    </ul>
                    <p>
                        Для реалізації будь-якого з цих прав надішліть запит на адресу{' '}
                        <a href={`mailto:${COMPANY_EMAIL}`} className="privacy-link">{COMPANY_EMAIL}</a>.
                        Ми розглянемо ваш запит протягом <strong>30 календарних днів</strong>.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>8. Захист даних</h2>
                    <p>
                        Продавець вживає організаційних та технічних заходів для захисту ваших
                        персональних даних від несанкціонованого доступу, втрати або розкриття:
                    </p>
                    <ul>
                        <li>передача даних через захищений протокол HTTPS;</li>
                        <li>обмежений доступ до персональних даних — лише для осіб, яким це необхідно
                            для виконання їхніх обов'язків;</li>
                        <li>регулярний перегляд практик безпеки.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>9. Зміни до Політики</h2>
                    <p>
                        Продавець залишає за собою право вносити зміни до цієї Політики. Актуальна
                        версія завжди доступна на сторінці{' '}
                        <strong>union-auto.com.ua/privacy-policy</strong>.
                    </p>
                    <p>
                        Продовження користування Сайтом після публікації змін означає вашу згоду з
                        оновленою Політикою.
                    </p>
                </section>

                <section className="privacy-section">
                    <h2>10. Контакти</h2>
                    <p>
                        З усіх питань щодо обробки персональних даних звертайтесь до Продавця:
                    </p>
                    <div className="privacy-contacts">
                        <div className="privacy-contact-row">
                            <span className="privacy-contact-label">Відповідальна особа</span>
                            <span className="privacy-contact-value">{OWNER}</span>
                        </div>
                        <div className="privacy-contact-row">
                            <span className="privacy-contact-label">Код ЄДРПОУ</span>
                            <span className="privacy-contact-value">{EDRPOU}</span>
                        </div>
                        <div className="privacy-contact-row">
                            <span className="privacy-contact-label">Email</span>
                            <span className="privacy-contact-value">
                                <a href={`mailto:${COMPANY_EMAIL}`} className="privacy-link">{COMPANY_EMAIL}</a>
                            </span>
                        </div>
                        <div className="privacy-contact-row">
                            <span className="privacy-contact-label">Юридична адреса</span>
                            <span className="privacy-contact-value">{COMPANY_ADDRESS}</span>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default PrivacyPage;
